import React from "react";
import { Create, ReactAdminComponentProps } from "react-admin";
import { EditActions } from "../../../common/form/FormActions";
import { VehicleMaintenanceForm } from "./VehicleMaintenanceForm";
import { useNotification } from "../../../../common/hooks/useNotification";
import { RouteComponentProps } from "react-router-dom";
import { CustomResourceRouteParams } from "../../../../common/types";

export const VehicleMaintenanceCreate = (
  props: RouteComponentProps<CustomResourceRouteParams> &
    ReactAdminComponentProps
) => {
  const notify = useNotification(props, "createSuccess");
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      transform={(record) => ({ ...record, vehicleId: props.match.params.id })}
      title="resources.assets-vehicle-maintenance.title.create">
      <VehicleMaintenanceForm />
    </Create>
  );
};
